module.exports = __webpack_public_path__ + "img/food-force-background.d9e88123.webp";